import type React from 'react';

export const LogoutImageIllustration: React.FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="247"
    height="224"
    viewBox="0 0 247 224"
    aria-hidden="true"
  >
    <defs>
      <path
        id="5t6qwkf14a"
        d="M.176 21.068c-.759 17.706 10.634 20.98 20.989 21.203l-.315 14.37h25.489l.125-12.872.055-5.764.049-5.03a6.562 6.562 0 00.055-13.126c-.14-.001-.277.01-.413.017 0 0 1.78-15.79-13.078-18.705a37.364 37.364 0 00-7.203-.725C9.864.436.569 11.922.176 21.068"
      ></path>
      <path
        id="j8piqwmync"
        d="M.176 21.068c-.759 17.706 10.634 20.98 20.989 21.203l-.315 14.37h25.489l.125-12.872.055-5.764.049-5.03a6.562 6.562 0 00.055-13.126c-.14-.001-.277.01-.413.017 0 0 1.78-15.79-13.078-18.705a37.364 37.364 0 00-7.203-.725C9.864.436.569 11.922.176 21.068"
      ></path>
      <path
        id="bgjkq9ivle"
        d="M.176 21.068c-.759 17.706 10.634 20.98 20.989 21.203l-.315 14.37h25.489l.125-12.872.055-5.764.049-5.03a6.562 6.562 0 00.055-13.126c-.14-.001-.277.01-.413.017 0 0 1.78-15.79-13.078-18.705a37.364 37.364 0 00-7.203-.725C9.864.436.569 11.922.176 21.068"
      ></path>
      <path
        id="9vmh0um01g"
        d="M161.525 9.433c12.151 32.404-.579 65.964-22.567 69.435-46.653 7.366-70.745-1.26-101.62 17.779C3.874 117.284.042 157.08 0 173.826v.571c.012 4.474.289 7.155.289 7.155l153.858-.674-4.745-54.506s29.958-6.054 47.454-35.899c8.362-14.266 11.11-30.564 11.138-45.622v-.487c-.037-18.934-4.341-35.842-7.123-44.188-14.466 2.892-28.931 8.1-39.346 9.257"
      ></path>
      <path
        id="bvouvz08xi"
        d="M161.525 9.433c12.151 32.404-.579 65.964-22.567 69.435-46.653 7.366-70.745-1.26-101.62 17.779C3.874 117.284.042 157.08 0 173.826v.571c.012 4.474.289 7.155.289 7.155l153.858-.674-4.745-54.506s29.958-6.054 47.454-35.899c8.362-14.266 11.11-30.564 11.138-45.622v-.487c-.037-18.934-4.341-35.842-7.123-44.188-14.466 2.892-28.931 8.1-39.346 9.257"
      ></path>
    </defs>
    <g fill="none" fillRule="evenodd">
      <path
        stroke="#E7EDF5"
        strokeWidth="2"
        d="M152.964 164H6.034A5.036 5.036 0 011 158.966V6.033A5.035 5.035 0 016.035 1h146.93A5.036 5.036 0 01158 6.033v152.933a5.035 5.035 0 01-5.036 5.034z"
      ></path>
      <path
        fill="#E7EDF5"
        d="M14 10.5a2.5 2.5 0 11-5.002-.002A2.5 2.5 0 0114 10.5m9 0a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0m10 0a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0m-15 26a1.5 1.5 0 11-3.001-.001A1.5 1.5 0 0118 36.5"
      ></path>
      <path
        stroke="#E7EDF5"
        strokeWidth="2"
        d="M22 36.5h61m-28 6h9m-28 0h15m-29 0h11"
      ></path>
      <path
        fill="#E7EDF5"
        d="M18 81.5a1.5 1.5 0 11-3.001-.001A1.5 1.5 0 0118 81.5"
      ></path>
      <path
        stroke="#E7EDF5"
        strokeWidth="2"
        d="M22 81.5h61m-28 6h9m-28 0h15m-29 0h11"
      ></path>
      <path
        fill="#E7EDF5"
        d="M29 51.5a1.5 1.5 0 11-3.001-.001A1.5 1.5 0 0129 51.5"
      ></path>
      <path stroke="#E7EDF5" strokeWidth="2" d="M33 51.5h51m-51 6h41"></path>
      <path
        fill="#E7EDF5"
        d="M18 67.5a1.5 1.5 0 11-3.001-.001A1.5 1.5 0 0118 67.5"
      ></path>
      <path
        stroke="#E7EDF5"
        strokeWidth="2"
        d="M22 67.5h61m-61 5h41M1 20l157-3"
      ></path>
      <path
        fill="#FFF"
        d="M65 164h90v-8H65zm5-33c0 4.419-3.582 8-8 8s-8-3.581-8-8h16z"
      ></path>
      <g>
        <path
          fill="#FFAA90"
          d="M92.177 97.688c.448-10.438 12.487-23.923 32.955-19.907 14.858 2.915 13.078 18.704 13.078 18.704.137-.007.274-.018.413-.017a6.563 6.563 0 01-.055 13.126l-.05 5.03-.054 5.765-.125 12.87h-25.49l.316-14.368c-10.354-.223-21.748-3.498-20.988-21.203"
        ></path>
        <g transform="translate(92 76.619)">
          <mask id="cewwdsm4pb" fill="#fff">
            <use xlinkHref="#5t6qwkf14a"></use>
          </mask>
          <path
            fill="#161C24"
            d="M36.908 13.052a7.103 7.103 0 007.105 7.104 7.105 7.105 0 10-7.105-7.104"
            mask="url(#cewwdsm4pb)"
          ></path>
        </g>
        <g transform="translate(92 76.619)">
          <mask id="csexpjp4gd" fill="#fff">
            <use xlinkHref="#j8piqwmync"></use>
          </mask>
          <path
            fill="#161C24"
            d="M28.928 6.09a7.104 7.104 0 107.104-7.104 7.104 7.104 0 00-7.104 7.105"
            mask="url(#csexpjp4gd)"
          ></path>
        </g>
        <g transform="translate(92 76.619)">
          <mask id="x4whoabt0f" fill="#fff">
            <use xlinkHref="#bgjkq9ivle"></use>
          </mask>
          <path
            fill="#161C24"
            d="M17.794 1.729a7.104 7.104 0 1014.208 0c0-3.924-3.18-7.104-7.104-7.104s-7.104 3.18-7.104 7.104"
            mask="url(#x4whoabt0f)"
          ></path>
        </g>
        <path
          stroke="#161C24"
          strokeLinecap="round"
          strokeWidth="1.5"
          d="M117.491 90.412l-.019 1.929m-14.892-2.088l-.019 1.929"
        ></path>
        <path
          fill="#161C24"
          d="M142.063 102.967a3.278 3.278 0 10-6.558-.063l6.558.063zm-28.916 15.927s9.029-.08 11.012-.151l-11.115 5.667.103-5.516zm-6.773-13.472l11.862-5.823s1.725 5.607-2.588 8.195c-4.314 2.588-9.274-2.372-9.274-2.372"
        ></path>
        <path
          stroke="#161C24"
          strokeLinecap="round"
          strokeWidth="1.5"
          d="M109.79 78.891l-.068 19.014H92.519"
        ></path>
        <path
          fill="#FFAA90"
          d="M206.372 57.753s-7.219-12.035-9.126-15.526c-1.908-3.492-1.349-4.289-.454-4.829s2.621.198 5.536 4.462c-2.56-5.646-2.658-6.517-3.14-7.652-1.496-3.508-1.185-6.478.066-7.003 1.573-.659 4.83 5.174 6.065 8.256-.603-4.757-3.235-11.525.266-12.438 2.303-.6 6.017 10.646 6.017 10.646s-.486-8.574 1.266-9.189c2.085-.732 3.693 3.094 4.508 5.593 2.578 7.9 4.256 16.87 4.543 20.543-3.407 1.866-15.547 7.137-15.547 7.137"
        ></path>
        <path
          stroke="#161C24"
          strokeLinecap="round"
          strokeWidth="1.5"
          d="M203.618 31.712c.364.748 2.141 5.388 2.93 7.23m5.914-2.166s-1.506-5.292-2.016-7.12m-8.66 11.521s1.209 1.622 1.87 2.983m-.912-1.661c.35-1.011 4.88-4.896 11.651-5.032"
        ></path>
        <path
          fill="#27DBA8"
          d="M76.339 138.266c30.874-19.039 54.966-10.413 101.62-17.779 21.987-3.472 34.716-37.032 22.565-69.435 10.416-1.157 24.881-6.365 39.347-9.258 5.014 15.044 14.971 57.908-4.016 90.297-17.494 29.845-47.453 35.9-47.453 35.9l4.745 54.506-153.857.674s-6.037-58.335 37.049-84.905"
        ></path>
        <g>
          <g transform="translate(39 41.619)">
            <mask id="j8ojji2kih" fill="#fff">
              <use xlinkHref="#9vmh0um01g"></use>
            </mask>
            <path
              stroke="#161C24"
              strokeLinecap="round"
              strokeWidth="2"
              d="M66.571 80.738L66.815 189"
              mask="url(#j8ojji2kih)"
            ></path>
          </g>
          <g transform="translate(39 41.619)">
            <mask id="qlaekmfmhj" fill="#fff">
              <use xlinkHref="#bvouvz08xi"></use>
            </mask>
            <path
              stroke="#161C24"
              strokeLinecap="round"
              strokeWidth="2"
              d="M109.248 75.782l8.885 105.885"
              mask="url(#qlaekmfmhj)"
            ></path>
          </g>
        </g>
        <g>
          <path
            fill="#161C24"
            d="M188.373 167.935l-1.145-11.916 10.55 8.92s-4.117 2.058-9.405 2.996"
          ></path>
          <path
            stroke="#161C24"
            strokeLinecap="round"
            strokeWidth="2"
            d="M72.99 176.035s-1.09 16.27-2.504 45.648"
          ></path>
        </g>
      </g>
    </g>
  </svg>
);
